import { render, staticRenderFns } from "./StoryboardEditorPage.vue?vue&type=template&id=cb4c708c&scoped=true"
import script from "./StoryboardEditorPage.vue?vue&type=script&lang=js"
export * from "./StoryboardEditorPage.vue?vue&type=script&lang=js"
import style0 from "./StoryboardEditorPage.vue?vue&type=style&index=0&id=cb4c708c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4c708c",
  null
  
)

export default component.exports